<div class="x-icon" (click)="closeMenu()">X</div>
<div class="search-button" (click)="closeMenu()">{{'SEARCH' | translate | uppercase}}</div>
<div class="card-header">{{'FILTER' | translate}}</div>
<div class="filter-container">
  <div class="left-container">
    <div class="types-container">
      <div class="subtitle">{{typeField.value | translatedb}}</div>
      <div class="types-selection">
        <div class="left">
          <div *ngFor="let type of types" (click)="selectOfferType(type)"
               [ngClass]="{'selected-type': type === this.currentlySelectedType}">{{type.type.value | translatedb}}</div>
        </div>
        <div class="right">
          <div *ngFor="let subtype of currentlySelectedType.subTypes" (click)="toggleSelected(subtype, 'type')">
            <input type="checkbox" [(ngModel)]="subtype.isSelected"
                   [checked]="subtype.isSelected">{{subtype.value | translatedb}}</div>
        </div>
      </div>
    </div>
    <div class="input-selection-container">
      <div class="small-title">{{'PRICE' | translate}}</div>
      <div class="input-number"> {{'FROM' | translate | lowercase}}
        <input #priceFrom (change)="filterOffers()">
        <div>€</div>
      </div>
      <div class="input-number"> {{'TO' | translate | lowercase}}
        <input #priceTo (change)="filterOffers()">
        <div>€</div>
      </div>
    </div>
    <div class="input-selection-container">
      <div class="small-title">{{'SPACE' | translate}}</div>
      <div class="input-number"> {{'FROM' | translate | lowercase}}
        <input #areaFrom (change)="filterOffers()">
        <div>м<sup>2</sup></div>
      </div>
      <div class="input-number"> {{'TO' | translate | lowercase}}
        <input #areaTo (change)="filterOffers()">
        <div>м<sup>2</sup></div>
      </div>
    </div>
    <div class="input-selection-container">
      <div class="small-title">{{'SEARCH_OFFER_BY_ID' | translate}}</div>
      <div class="input-number"><input #offerID (change)="filterOffers()"></div>
    </div>
    <div class="sales-or-rents">
      <div class="major-type" [ngClass]="{'selected': salesSelected}"
           (click)="toggleSales()">{{'SALES' | translate}}</div>
      <div class="major-type" [ngClass]="{'selected': rentsSelected}"
           (click)="toggleRents()">{{'RENTS' | translate}}</div>
    </div>
  </div>
  <div class="right-container">
    <div class="subtitle">{{regionField.value | translatedb}}</div>
    <div class="regions-container">
      <div *ngFor="let region of regions" [ngClass]="{'selected': region.isSelected}"
           (click)="toggleSelected(region, 'region')">{{region.value | translatedb}}
      </div>
    </div>
  </div>
</div>
